import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'

import { message, Form, Input, Popconfirm, InputNumber, Button, Table } from "antd";
import { db, storr } from '../firebase/firebase';
import {
    SearchOutlined,
} from '@ant-design/icons';
const data = [];

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};




class Media extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checky: false,
            selectedFile: null,
            disallow: true,
            invalidPage: false,
            downloadlink: "",
            pendingData: { disabled: true, inputDisabled: false },
            data,
            da: null,
            master: [],
            sd: [],
            editingKey: ''
        };
        this.pageCheck()
        this.columns = [
            {
                title: 'File name',
                dataIndex: 'filename',
                editable: true,
                ...this.getColumnSearchProps('filename'),
                sorter: (a, b) => { return a.filename.localeCompare(b.filename) },
            },
            {
                title: 'Upload Date',
                dataIndex: 'timestamp',
                sorter: (a, b) => parseInt(a.timestamp, 10) - parseInt(b.timestamp, 10),
                render: (text, record) => {
                    return (
                        <div>
                            {this.toLocalTime(text)}

                        </div>
                    );
                },
            },
            {
                title: 'Media Link',
                dataIndex: 'link',
                editable: false,
                render: (text, record) => {
                    return (
                        <div>
                            <a href={record.link} target="_blank">
                                <img src={record.link} alt="" height='150' />
                            </a>
                        </div>
                    );
                },
            },
            {
                title: '',
                width: '10%',
                dataIndex: 'operation',
                render: (text, record) => {
                    return (
                        <div>
                            <Popconfirm
                                title="Sure to delete?"
                                onConfirm={() => this.deleteProject(record.key)}
                            >
                                <Button type="danger">Delete</Button>
                            </Popconfirm>
                        </div>
                    );
                },
            },
        ];

        this.deleteProject = this.deleteProject.bind(this)
        this.pullFromDB()

    }

    pageCheck = () => {
        var iden = this.props.match.params.id
        var Temptitle = this.props.match.params.title
        var self = this
        db.collection("events").doc(iden).get()
            .then(function (doc) {
                if (doc.exists && doc.data().title === Temptitle) {
                    self.setState({ invalidPage: false })
                } else {
                    message.error("invalid url")
                    if (self.state.invalidPage != null)
                        self.setState({ invalidPage: true })
                }
            }).catch(function (error) {
                message.error("error url")
                if (self.state.invalidPage != null)
                    self.setState({ invalidPage: true })
            });
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys, selectedKeys, confirm, clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => { this.searchInput = node; }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => this.handleReset(clearFilters)}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            text
        ),
    })

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }

    handleReset = (clearFilters) => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    isEditing = (record) => {
        return record.key === this.state.editingKey;
    };


    handleChange = () => {
        // 
        // this.addEvent();
        let sd = [];
        //asign key to the array!
        for (var i = 0; i < Object.keys(this.state.master.medias).length; i++) {

            sd.push({
                link: Object.values(this.state.master.medias)[i],
                key: i.toString(),
            });

            // console.log("SD state!! " + JSON.stringify(this.state.sd))
            // console.log("DATA state!! " + JSON.stringify(this.state.data))
        }
        this.setState({ sd });
    }

    pullFromDB = () => {
        var baba;
        if (this.props.match.params.id) {
            baba = this.props.match.params.id
        }
        // We listen for live changes to our data collection in Firebase
        db.collection("eventmedias").where("event", "==", baba).onSnapshot(snapshot => {
            //data is locally available array, pulled from firestore.
            let data = [];
            snapshot.forEach(doc => {
                const todo = doc.data();
                todo.id = doc.id;
                data.push(todo);
            });

            // Sort our data based on time added
            data.sort(function (a, b) {
                return (
                    new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
                );
            });

            //assign primary key
            for (var i = 0; i < data.length; i++) {
                data[i].key = i;
            }
            // console.log(data);

            // Anytime the state of our database changes, we update state
            this.setState({ data });

        })
        // var ref = db.collection("eventmedias").doc(this.props.match.params.id)
        // ref.get().then((doc) => {

        //     this.setState({
        //         master: doc.data(),
        //     });
        //     this.handleChange();
        // })


    }

    uploadThenAddToDatabase = (ahh) => {
        message.loading('Uploading...')
        console.log(JSON.stringify(ahh))
        var docy = db.collection("eventmedias").doc()

        var refy = storr.ref(docy.id + ahh.file.name.substring(ahh.file.name.lastIndexOf('.'), ahh.file.name.length));

        var self = this

        refy.put(ahh.file).then(function (doc) {
            refy.getDownloadURL().then((url) => {
                docy.set({
                    timestamp: Date.now(),
                    event: self.props.match.params.id,
                    filename: ahh.file.name,
                    link: url
                })
                if (document.getElementById("uploadCaptureInputFile"))
                    document.getElementById("uploadCaptureInputFile").value = ""
                ahh.file = null
                ahh.inputDisabled = false
                ahh.disabled = true
                self.setState({ pendingData: ahh })
                message.destroy()
                message.success("Uploaded successfully")
            })

        });
    }

    componentWillUnmount() {
        document.getElementById("uploadCaptureInputFile").value = ""
    }

    addProject = () => {
        if (this.state.pendingData.file != null) {
            var tempC = this.state.pendingData
            tempC.inputDisabled = true
            tempC.disabled = true
            this.setState({ pendingData: tempC })

            this.uploadThenAddToDatabase(this.state.pendingData)
        } else {
            message.error("Something wrong happened, no file was in it")
        }

    }
    async deleteProject(id) {
        // alert("record.key: " + id + "todo id: " + this.state.data[id].id)
        var fn = this.state.data[id].filename
        var idea = this.state.data[id].id

        var ext = fn.substring(fn.lastIndexOf('.'), fn.length)

        await db
            .collection("eventmedias")
            .doc(idea)
            .delete().then(function () {
                message.success("Row deleted successfully")
                var ref = storr.ref(idea + ext);
                // Get the download URL
                ref.delete().then(function () {
                    message.success("File " + fn + " deleted successfully")
                }).catch(function (error) {
                    message.error(error.message)
                });
            }).catch(function (error) {
                message.error(error.message)
            });
    }

    toLocalTime = (ts) => {
        var dt = new Date(ts).toLocaleString();
        return dt
    }




    //OLD VERSION THAT USE AXIOS HTTP REQUEST TO CLOUD FUNCTION.
    // fileUpload = () => {
    //     var na = moment().toISOString()
    //     const formData = new FormData()
    //     formData.append('image', this.state.selectedFile, na + this.state.selectedFile.name)
    //     axios.post('https://us-central1-lemonbase-ee2df.cloudfunctions.net/uploadFile', formData, {
    //         onUploadProgress: progressEvent => {
    //             console.log(progressEvent.loaded / progressEvent.total)
    //         }
    //     })
    //         .then(res => console.log(res))
    //     this.addProject(na, this.state.selectedFile.name);
    // }

    blockit = () => {
        this.setState({ disallow: true })
    }

    clearInputFile = () => {
        var tempB = this.state.pendingData
        document.getElementById("uploadCaptureInputFile").value = ""
        tempB.file = null
        tempB.disabled = true
        this.setState({ pendingData: tempB })
    }

    handlePreuploadFile = (event) => {
        var abb = this.state.pendingData;

        if (event.target.files[0]) {
            if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpeg') {
                console.log("accepted file format")
                if (event.target.files[0].size < 100000000) {
                    abb.disabled = false
                    message.info("You inputed " + event.target.files[0].name)
                    abb.file = event.target.files[0]
                } else {
                    message.error("File is too big");
                    event.target.value = ""
                    abb.file = null
                    abb.disabled = true
                }
            } else {
                message.error("Not the accepted file type");
                event.target.value = ""
                abb.file = null
                abb.disabled = true
            }
        } else {
            message.error("No file in it");
            event.target.value = ""
            abb.file = null
            abb.disabled = true
        }

        this.setState({ pendingData: abb });
    }


    render() {
        const components = {
            body: {

                cell: EditableCell,
            },
        };

        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });

        return (
            <div>
                <h1>{this.props.match.params.title}</h1>
                <br></br>
                {!this.state.pendingData.disabled &&
                    <div className="gutter-box">
                        <Button
                            type="danger"
                            onClick={this.clearInputFile}
                            disabled={this.state.pendingData.inputDisabled}
                            ghost
                        >
                            Clear file
                        </Button>
                    </div>
                }
                <input type="file"
                    id="uploadCaptureInputFile"
                    accept="image/*"
                    onChange={this.handlePreuploadFile}
                    disabled={this.state.pendingData.inputDisabled}
                />
                <div className="gutter-box">
                    <Button
                        className="inputt App-add-todo-button"
                        size="large"
                        type="primary"
                        onClick={this.addProject}
                        disabled={this.state.pendingData.disabled}
                    >
                        Add a Media file
                    </Button>
                </div>


                < Table
                    components={components}
                    bordered
                    dataSource={this.state.data}
                    columns={columns}
                    rowClassName="editable-row"
                />
                {this.state.invalidPage ?
                    <Redirect to='/dashboard' />
                    :
                    <div />
                }

            </div >
        );
    }
}

export default Media;



// WEBPACK FOOTER //
// ./src/views/media.js